import React, { createContext, useContext, useRef } from "react";
import type { ReactNode } from "react";

type KioskProviderProps = { children: ReactNode };
type KioskContextProps = {
  yearRangeElement: any;
  abvRangeElement: any;
  sizeRangeElement: any;
};

const KioskContext = createContext<KioskContextProps>({
  yearRangeElement: {},
  abvRangeElement: {},
  sizeRangeElement: {},
});

export const KioskProvider = (props: KioskProviderProps) => {
  const yearRangeElement = useRef(null);
  const abvRangeElement = useRef(null);
  const sizeRangeElement = useRef(null);

  return (
    <KioskContext.Provider
      value={{
        yearRangeElement,
        abvRangeElement,
        sizeRangeElement,
      }}
      {...props}
    />
  );
};

export const useKioskContext = (): KioskContextProps =>
  useContext(KioskContext);
